import Sizes from './Sizes';


export default {
    AUTO_FOCUS_QUESTION_TOP: Sizes.SPACING.THREE,
    PAGE_INTRO_HEIGHT: Sizes.SPACING.FIVE,
    QUESTION_COLUMN_GAP: Sizes.SPACING.FOUR,
    QUESTION_COLUMN_MIN_WIDTH: 240,
};